import React, { createContext, useContext, useState } from 'react';

const DEFAULT_PRESET_HOURS = [
  '7:30-16:30',
  '9:00-17:00',
  '16:30-00:30',
];

const PresetHoursContext = createContext();

export const usePresetHours = () => useContext(PresetHoursContext);

export const PresetHoursProvider = ({ children }) => {
  const [presetHours, setPresetHours] = useState(DEFAULT_PRESET_HOURS);

  return (
    <PresetHoursContext.Provider value={{ presetHours, setPresetHours }}>
      {children}
    </PresetHoursContext.Provider>
  );
};
